import type { SVGProps } from 'react'

const SvgSensorModel = (props: SVGProps<SVGSVGElement>) => (
  <svg fill='none' viewBox='0 0 24 24' {...props}>
    <path d='M6 2a4 4 0 0 0-4 4v12a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4V6a4 4 0 0 0-4-4zm6.1 1.5c.469 0 .851.38.851.85V5.2H15.5a1.7 1.7 0 0 1 1.701 1.7v6.8a1.7 1.7 0 0 1-1.701 1.7h-2.549v4.25a.851.851 0 0 1-1.701 0V15.4H8.701A1.7 1.7 0 0 1 7 13.7v-6.8a1.7 1.7 0 0 1 1.701-1.7h2.549V4.35c0-.47.38-.85.85-.85m0 4.25a2.551 2.551 0 0 0-2.551 2.549 2.552 2.552 0 0 0 3.344 2.424A2.548 2.548 0 0 0 12.1 7.75' />
  </svg>
)

export default SvgSensorModel
